import React from 'react'

const Text = ({ component, className, children, ...rest }) =>
  React.createElement(component, { ...rest, className }, children)

Text.defaultProps = {
  component: 'span',
  className: '',
}

export default Text
